import AWS from 'aws-sdk'
import uuid from 'uuid/v4'

AWS.config.region = process.env.VUE_APP_AWS_REGION
AWS.config.credentials = new AWS.CognitoIdentityCredentials({
  IdentityPoolId: process.env.VUE_APP_AWS_IDENTITY_POOL_ID,
})

const kinesis = new AWS.Kinesis()

export const sendKinesisHeartbeat = ({
  position,
  delta,
  user_id,
  account_id,
  team_ids,
  video_id,
  video_name,
  parent_data,
}) => {
  const heartbeat = {
    event_type: 'heartbeat',
    attributes: {
      position: JSON.stringify(position * 1000),
      delta: JSON.stringify(delta * 1000),
      app: process.env.VUE_APP_AWS_APP,
      heartbeat_version: process.env.VUE_APP_AWS_VERSION,
      uuid: uuid(),
      user_id,
      team_id: team_ids && team_ids.length ? team_ids.join(', ') : '',
      account_id: account_id && account_id.length ? account_id : '',
      video_id,
      video_name,
      timestamp: new Date().toISOString(),
    },
  }
  heartbeat.attributes = { ...heartbeat.attributes, ...parent_data }
  const params = {
    Data: JSON.stringify(heartbeat),
    PartitionKey: 'heartbeat',
    StreamName: process.env.VUE_APP_AWS_KINESIS_STREAM,
  }
  kinesis.putRecord(params, err => {
    if (err) console.log(err, err.stack) // an error occurred
  })
}

export const sendKinesisQuizbeat = ({
  user_id,
  account_id,
  team_ids,
  quiz_id,
  score,
  time_elapsed,
  video_id,
  course_id,
  course_slug,
  instructor_id,
}) => {
  const quizbeat = {
    event_type: 'quizbeat',
    attributes: {
      uuid: uuid(),
      app: process.env.VUE_APP_AWS_APP,
      quizbeat_version: process.env.VUE_APP_QUIZBEATS_VERSION,
      user_id,
      account_id: account_id && account_id.length ? account_id : '',
      team_id: team_ids && team_ids.length ? team_ids.join(', ') : '',
      quiz_id,
      score,
      time_elapsed,
      video_id,
      course_id,
      course_slug,
      instructor_id,
      timestamp: new Date().toISOString(),
    },
  }
  const params = {
    Data: JSON.stringify(quizbeat),
    PartitionKey: 'quizbeat',
    StreamName: process.env.VUE_APP_AWS_KINESIS_STREAM,
  }
  kinesis.putRecord(params, err => {
    if (err) console.log(err, err.stack) // an error occurred
  })
}
